import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { NotificationSettings } from "@/components/NotificationSettings";
import {
  ArrowLeft,
  UserCircle,
  CreditCard,
  Bell,
  Shield,
  Palette,
  Globe,
  HelpCircle,
  ChevronRight,
} from "lucide-react";

const GROUPS = [
  { icon: UserCircle, label: "Account Information" },
  { icon: CreditCard, label: "Subscription & Billing" },
  { icon: Bell, label: "Notifications" },
  { icon: Shield, label: "Privacy" },
  { icon: Palette, label: "Appearance" },
  { icon: Globe, label: "Language" },
  { icon: HelpCircle, label: "Help & Support" },
];

export default function Settings() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [pub, setPub] = useState(!!user?.follow_public);
  const setPrivacy = async (v) => {
    setPub(v);
    try {
      await api.put("/me/privacy", { follow_public: v });
      toast.success(v ? "Creators you follow can see your username" : "You now follow creators privately");
    } catch {
      setPub(!v);
      toast.error("Couldn't update privacy");
    }
  };
  return (
    <div data-testid="settings-screen" className="px-5 pt-6">
      <header className="flex items-center gap-3">
        <button onClick={() => navigate("/app/profile")} className="text-[#a7a0af] hover:text-white">
          <ArrowLeft size={22} />
        </button>
        <h1 className="text-xl font-bold">Settings</h1>
      </header>

      <label className="mt-6 flex items-center gap-3 rounded-2xl glass px-4 py-4">
        <span className="flex-1">
          <span className="block text-sm">Show my username to creators I follow</span>
          <span className="block text-[0.65rem] text-[#a7a0af]">Off by default. When off, you appear as a private follower.</span>
        </span>
        <Switch checked={pub} onCheckedChange={setPrivacy} data-testid="settings-follow-public" />
      </label>

      <NotificationSettings audience="subscriber" />

      <ul className="mt-4 overflow-hidden rounded-2xl glass">
        {GROUPS.map(({ icon: Icon, label }, i) => (
          <li
            key={label}
            data-testid={`settings-row-${label.split(" ")[0].toLowerCase()}`}
            className={`flex items-center gap-3 px-4 py-4 ${i > 0 ? "border-t border-white/5" : ""}`}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5">
              <Icon size={17} className="text-[#d42be8]" />
            </span>
            <span className="flex-1 text-sm">{label}</span>
            <ChevronRight size={16} className="text-[#6f6878]" />
          </li>
        ))}
      </ul>

      <p className="mt-6 text-center text-[0.65rem] text-[#6f6878]">
        PEEPING · COME CLOSER
      </p>
    </div>
  );
}
